export default __webpack_public_path__ + "static/media/cp_bx_box.dd60f2b7.svg";